<template>
	<Menu same-width :gutter="2" @select="onSelect">
		<template #trigger>
			<Button class="trigger" :size="size" variant="primary" :disabled="busy">
				<AppIcon :name="IconName.Download" class="download-icon" :size="16" :stroke-width="1.75" />
				<span>{{
					busy ? busyLabel ?? t("callToActions.exportingParcel") : label ?? t("callToActions.exportParcel")
				}}</span>
				<AppIcon :name="IconName.ChevronDown" class="chevron" :size="10" :stroke-width="2" />
			</Button>
		</template>

		<MenuItem value="shapefile" class="export-menu-item">
			<span class="format">Shapefile</span>
			<span class="description">{{ shapefileDescription ?? t("callToActions.shapefileExportDescription") }}</span>
		</MenuItem>
		<MenuItem value="kml" class="export-menu-item">
			<span class="format">KML</span>
			<span class="description">{{ kmlDescription ?? t("callToActions.kmlExportDescription") }}</span>
		</MenuItem>
	</Menu>
</template>

<script setup lang="ts">
import { useI18n } from "vue-i18n"
import AppIcon from "@/components/AppIcon.vue"
import { IconName } from "@/components/icons/registry"
import type { MenuSelectionDetails } from "@ark-ui/vue"
import Button from "@/components/ui/Button.vue"
import Menu from "../ui/Menu.vue"
import MenuItem from "../ui/MenuItem.vue"
import type { ParcelExportFormat } from "@/utils/ApiClient"

const {
	busy = false,
	size = "m",
	label,
	busyLabel,
	shapefileDescription,
	kmlDescription,
} = defineProps<{
	busy?: boolean
	size?: "xs" | "s" | "m" | "l"
	label?: string
	busyLabel?: string
	shapefileDescription?: string
	kmlDescription?: string
}>()
const emit = defineEmits<{ select: [format: ParcelExportFormat] }>()
const { t } = useI18n()

function onSelect(details: MenuSelectionDetails): void {
	emit("select", details.value as ParcelExportFormat)
}
</script>

<style scoped>
.trigger {
	width: 100%;

	.download-icon {
		flex-shrink: 0;
		margin-right: var(--spacing-xxs);
	}

	.chevron {
		flex-shrink: 0;
		margin-left: var(--spacing-xs);
	}
}

.export-menu-item {
	display: flex;
	flex-direction: column;
	gap: 2px;
	white-space: normal;

	.format {
		font-size: var(--font-size-small);
		font-weight: var(--font-weight-semibold);
	}

	.description {
		color: var(--neutral-600);
		font-size: var(--font-size-xxs);
		line-height: var(--line-height-normal);
	}
}
</style>
